export default {"src":"/_next/static/media/0x1622bf67e6e5747b81866fe0b85178a93c7f86e3.1b1a27c3.svg","height":1000,"width":1000,"blurWidth":0,"blurHeight":0};